{{#each this}}
<li class='glide__slide--elem footer-modal__card'>
    <div class='headshot headshot-2'>
        <img class='student-foto' src={{img}} alt={{name}} />
    </div>
    <div class='student__card'>
        <h3 class='student__name'>{{name}}</h3>
        <p class='student__role'>{{role}}</p>
        <h3 class='student__name'>My favorite <span class="fav-movie">Movies</span> and <span>Series</span> are:</h3>
        <p class='fav_movie'>
            {{movies}}
        </p>
        <p class='fav-serie'>
            {{series}}
        </p>
    </div>
</li>
{{/each}}